import { render, staticRenderFns } from "./CoefficientSalaryList.vue?vue&type=template&id=1dff6cf4&scoped=true"
import script from "./CoefficientSalaryList.vue?vue&type=script&lang=js"
export * from "./CoefficientSalaryList.vue?vue&type=script&lang=js"
import style0 from "./CoefficientSalaryList.vue?vue&type=style&index=0&id=1dff6cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dff6cf4",
  null
  
)

export default component.exports